/**
 * @author Joydeep Nayak
 * @description Component to get value from source and display in the textbox
 * @example <TwoWayTextfieldWidget onChange={props.onChange} {...props} />
 */

import * as React from "react";
import { connect } from "react-redux";
import IDynamicLabelProps from "./IDynamicLabelPropsType";
import "../../../assets/sass/widgets/dynamicLabelWidget.scss";

interface IDynamicLabelState {
    dataSources?: string[];
}

/**
 * @class DynamicLabel
 * @category Widgets
 * @description the input box which get the value from the another field in the form depending on the store value passed as the configuration Ex: Addressee which get the value
 * from either company name or first name and last name
 */
class DynamicLabel extends React.Component<IDynamicLabelProps, IDynamicLabelState, {}> {
    constructor(props) {
        super(props);
        this.state = {
            dataSources: [],
        };
        this.inputFieldChange = this.inputFieldChange.bind(this);
        this.addDataToDataSource = this.addDataToDataSource.bind(this);
        this.valueResolver = this.valueResolver.bind(this);
    }
    componentDidMount() {
        if (!this.props.value) {
            this.props.onChange(this.props.schema.default);
        }
        if (this.props.schema.const && this.props.schema.const.dataSource.length > 0) {
            this.setState({ dataSources: this.props.schema.const.dataSource }, () => {
                this.addDataToDataSource(this.props.schema.const.dataSource);
            });
        }
    }
    // compares the current props value and previous props value and does a callback if they are not equal
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.addDataToDataSource(nextProps.schema.const.dataSource) !==
            this.addDataToDataSource(this.props.schema.const.dataSource)
        ) {
            this.addDataToDataSource(this.props.schema.const.dataSource);
        }
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        if (
            this.addDataToDataSource(nextProps.schema.const.dataSource) !==
            this.addDataToDataSource(this.props.schema.const.dataSource)
        ) {
            this.props.onChange(this.addDataToDataSource(this.props.schema.const.dataSource));
        }
    }
    inputFieldChange(e) {
        this.props.onChange(e.target.value);
    }

    addDataToDataSource(dataSources: any) {
        let value = "";
        for (let i = 0; i < dataSources.length; i++) {
            const splitArr = dataSources[i].nodes.split("|");
            for (let j = 0; j < splitArr.length; j++) {
                if (this.valueResolver(this.props.sourceValue, splitArr[j])) {
                    if (this.valueResolver(this.props.sourceValue, splitArr[j]) !== "") {
                        value =
                            value + dataSources[i].seperator + this.valueResolver(this.props.sourceValue, splitArr[j]);
                    }
                }
            }
            if (value !== "") {
                break;
            }
        }
        if (this.props.value !== value) {
            this.props.onChange(value);
        }
        return value.trim();
    }

    // reusable method to get value from source
    valueResolver(obj: any, key: any) {
        const valKey = key.split(".");
        if (!obj) {
            return;
        }
        if (valKey.length === 1) {
            return obj[valKey[0]];
        }
        return this.valueResolver(obj[valKey[0]], valKey.splice(1).join("."));
    }

    render() {
        const { id, value, schema } = this.props;
        return (
            <div>
                <label htmlFor={id} className="gaf-twoway-inputBox-label">
                    {value}
                </label>
                <input
                    type="text"
                    value={value}
                    onChange={this.inputFieldChange}
                    className="gaf-twoway-inputBox"
                    id={id}
                    disabled={schema.const.readOnly}
                />
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        sourceValue: state.dynamicFormInfo.warrantyInfo,
    };
}

export default connect(mapStateToProps, {})(DynamicLabel);
